
  exports.formatDate=(value)=> {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      return y + '-' + MM + '-' + d;
  },
  exports.path=(val)=>{
    let imgpath=".//static/img/"+val
    return imgpath
  },
  exports.makeaccounts=(value,key)=>{
    value=''+value
    var at=6
    if(key){
      at=key
    }
    else if(value.length<6){
      for(let i =value.length;i<6;i++){
        value='0'+value
      }
    }
    let priceval
    let mokey=""+value
    if(value!="" && typeof(value) != "undefined"){
      var a1=(mokey.substr(0,mokey.length-at))
      var a2=mokey.substr(-at,at)
      priceval=parseFloat(a1+'.'+a2)
    }
    return priceval
  },
  exports.number=(data, n) => {
    if(data!='0'&&data!="0.00"&&data!==undefined){
      if(data!=""&&data!="null"&&typeof data != 'undefined'){
        return parseFloat(data).toFixed(n+1)
      }
    }
    else{
      let a=0.00
      return a
    }
  },
  exports.money=(money)=>{
    if(money && money!=null){
        money = String(money);
        var left=money.split('.')[0],right=money.split('.')[1];
        right = right ? (right.length>=2 ? '.'+right.substr(0,2) : '.'+right+'0') : '.00';
        var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
        return (Number(money)<0?"-":"") + temp.join(',').split('').reverse().join('')+right;
    }else if(money===0){
        return '0.00';
    }else{
        return "";
    }
  },
  exports.formatDateTime=(inputTime)=>{ 
    let date = new Date(inputTime); 
    let y = date.getFullYear(); 
    let m = date.getMonth() + 1; 
    m = m < 10 ? ('0' + m) : m; 
    let d = date.getDate(); 
    d = d < 10 ? ('0' + d) : d; 
    let h = date.getHours(); 
    h = h < 10 ? ('0' + h) : h; 
    let minute = date.getMinutes(); 
    let second = date.getSeconds(); 
    minute = minute < 10 ? ('0' + minute) : minute; 
    second = second < 10 ? ('0' + second) : second; 
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second; 
  },
  exports.idcartype=(val) => {
    let str=''
    let va={
      Ent04: "社会统一信用代码",
      Ind01: "身份证",
      Ind03: "护照",
      Ind06: "港澳居民来往内地通行证",
      Ind07: "台湾同胞来往内地通行证",
      Ind11: "其他个人证件",
      Ind12: "香港身份证",
      Ind13: "澳门身份证",
      Ind14: "台湾身份证"
    }
    for(var key in va){
        if(key==val){
          str=va[val]
        }
    }
    return str
  },
  exports.organizationtype=(val) => {
    let str=''
    val=""+val
    switch(val)
    {
      case '0101': 
        str="法人企业"
      break;
      case '0102': 
        str="非法人企业"
      break;
      case '0103': 
        str="事业单位"
      break;
      case '0104':
        str="社会团体"
      break;
      case '0105': 
        str="党政机关"
      break;
    }
    return str
  },
  exports.datastyle=(data) => {
    let txt=""
    switch(data)
    {
      case 410:
      txt="待还款"
      break;
      case 400:
      txt="待放款"
      break;
      case 220:
      txt="待审核"
      break;
      case 100:
      txt="待审核"
      break;
      case 600:
      txt="已结清"
      break;
      case 320:
      txt="已关闭"
      break;
    }
    return txt
  },
  exports.resentation=(val)=>{
    let rnme=""
    switch(val)
    {
      case 1:
      rnme="个人征信授权"
      break
      case 2:
      rnme="公司征信授权"
      break
      case 3:
      rnme="债务确认书"
      break
      case 4:
      rnme="保证担保合同"
      break
      case 5:
      rnme="平台服务协议"
      break
    }
    return rnme
  },  
  exports.repaystatus=(val)=>{
    let rtit=""
    switch(val)
    {
      case 0:
      rtit="未还款"
      break
      case 1:
      rtit="已还款"
      break
      case 2:
      rtit="提前结清"
      break
      case 3:
      rtit="逾期还款"
      break
      case 4:
      rtit="逾期未还"
      break
    }
    return rtit
  },
  exports.monthnum=(data)=>{
    if(data<10){
      data="0"+data
    }
    return data
  },
  exports.attribute=(data)=>{
    let rtit=""
    switch(data)
    {
      case 1:
      rtit="幻灯片广告"
      break
      case 2:
      rtit="产品介绍"
      break
      case 3:
      rtit="图文广告"
      break
      case 4:
      rtit="头条推荐"
      break
    }
    return rtit
  }
  exports.numbersodd=(data)=>{
    let ab=data
    if(data!=""&&data.length>10){
      ab=data.substring(0,6)+'……'+data.substring(data.length-6,data.length)
    }
    return ab
  }
  exports.examinetype=(val)=>{
    let nm=''
    switch(val){
      case 0:
      nm='企业信息变更'
      break
      case 1:
      nm='授权人信息变更'
      break
      case 2:
      nm='收款信息变更'
      break
    }
    return nm
  }



// WEBPACK FOOTER //
// ./src/filter.js